import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";

type QMResultsListItem = {
  data: {
    responseDate: string;
    averageScore: string;
    result: string;
  };
  handleListSelection: (resultItem: any) => void;
};

export const QMResultsListItem = (props: QMResultsListItem) => {
  const { responseDate, result, averageScore } = props.data;

  const handleClick = (event: any) => {
    event.preventDefault();
    props.handleListSelection(props.data);
  };

	const parsedAverageScore = (averageScore: string) => {
		return parseFloat(averageScore).toFixed(2);
	}

  const dateValue = new Date(parseInt(responseDate)).toLocaleDateString();
  return (
    <ListItem>
      <ListItemButton
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "space-evenly",
          gap: "1rem",
        }}
        onClick={handleClick}
      >
        <ListItemText>
          <Typography variant="h5">{dateValue}</Typography>
        </ListItemText>
        <ListItemText>
          <Typography variant="h5">{parsedAverageScore(averageScore)}</Typography>
        </ListItemText>
        <ListItemText>
          <Typography variant="h5">{result}</Typography>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
};
